(function () {
  "use strict";

  // --- Konstanten (identisch zur Function) ---------------------------------
  var CONSTANTS = { pi: Math.PI, PI: Math.PI, e: Math.E };
  var FUNCTIONS = {
    sqrt: Math.sqrt, abs: Math.abs, min: Math.min, max: Math.max,
    round: Math.round, ceil: Math.ceil, floor: Math.floor,
  };
  var DIMENSION_KEYS = [
    "height_back", "height_front", "width", "depth", "height", "diameter",
    "width_left", "width_right", "width_top", "height_table",
    "depth_top", "depth_bottom",
    "circumference_top", "circumference_bottom", "circumference_center",
  ];

  function toNumber(v) {
    if (v == null) return NaN;
    return parseFloat(String(v).replace(",", "."));
  }
  function toCharmPrice(p) {
    return Math.floor(p / 10) * 10 + 9;
  }

  // --- Sicherer Formel-Auswerter (recursive descent, kein eval) ------------
  function evalExpr(expr, scope) {
    var s = String(expr), i = 0;
    function skipWs() { while (i < s.length && /\s/.test(s[i])) i++; }
    function parsePrimary() {
      skipWs();
      if (s[i] === "(") {
        i++; var v = parseExpression(); skipWs();
        if (s[i] !== ")") throw new Error("Erwartet ')'"); i++; return v;
      }
      var num = /^\d*\.?\d+/.exec(s.slice(i));
      if (num) { i += num[0].length; return parseFloat(num[0]); }
      var id = /^[A-Za-z_]\w*/.exec(s.slice(i));
      if (id) {
        i += id[0].length; var name = id[0]; skipWs();
        if (s[i] === "(") {
          var fn = FUNCTIONS[name];
          if (!fn) throw new Error("Unbekannte Funktion: " + name);
          i++; var args = [parseExpression()]; skipWs();
          while (s[i] === ",") { i++; args.push(parseExpression()); skipWs(); }
          if (s[i] !== ")") throw new Error("Erwartet ')'"); i++;
          return fn.apply(null, args);
        }
        if (name in CONSTANTS) return CONSTANTS[name];
        if (name in scope) return scope[name];
        throw new Error("Unbekannte Variable: " + name);
      }
      throw new Error("Unerwartetes Zeichen an Position " + i);
    }
    function parseUnary() {
      skipWs();
      if (s[i] === "+" || s[i] === "-") { var op = s[i++]; var v = parseUnary(); return op === "-" ? -v : v; }
      return parsePower();
    }
    function parsePower() {
      var base = parsePrimary(); skipWs();
      if (s[i] === "^") { i++; return Math.pow(base, parseUnary()); }
      return base;
    }
    function parseTerm() {
      var v = parseUnary(); skipWs();
      while (s[i] === "*" || s[i] === "/") {
        var op = s[i++]; var rhs = parseUnary(); v = op === "*" ? v * rhs : v / rhs; skipWs();
      }
      return v;
    }
    function parseExpression() {
      var v = parseTerm(); skipWs();
      while (s[i] === "+" || s[i] === "-") {
        var op = s[i++]; var rhs = parseTerm(); v = op === "+" ? v + rhs : v - rhs; skipWs();
      }
      return v;
    }
    var result = parseExpression(); skipWs();
    if (i < s.length) throw new Error("Unerwarteter Rest: '" + s.slice(i) + "'");
    return result;
  }

  // Mehrere ';'-getrennte Anweisungen mit lokalen Zuweisungen (z.B. "D=(w+d)/2; PI*(D/2)^2 ...")
  function evaluateFormula(formula, vars) {
    var scope = Object.assign({}, vars);
    var statements = String(formula).split(";").map(function (p) { return p.trim(); }).filter(Boolean);
    if (statements.length === 0) throw new Error("Leere Formel");
    var last = NaN;
    for (var k = 0; k < statements.length; k++) {
      var m = /^([A-Za-z_]\w*)\s*=\s*([\s\S]+)$/.exec(statements[k]);
      if (m) { last = evalExpr(m[2], scope); scope[m[1]] = last; }
      else { last = evalExpr(statements[k], scope); }
    }
    return last;
  }

  // --- Hauptfunktion: Preis (Charm) oder null ------------------------------
  // config: { formula, a, b }  (a/b serverseitig in Liquid aus den Metafeldern
  //          verschmolzen – siehe Kopfkommentar).
  // rawDims: { height_back: "78", width: "70", ... }  (Strings ok, Komma ok)
  function computePrice(config, rawDims) {
    if (!config) return null;
    var formula = config.formula;
    var a = Number(config.a);
    var b = Number(config.b);
    if (typeof formula !== "string" || !(a > 0) || !isFinite(b)) return null;

    var vars = {};
    for (var k = 0; k < DIMENSION_KEYS.length; k++) {
      var key = DIMENSION_KEYS[k], n = toNumber(rawDims[key]);
      if (!isNaN(n)) vars[key] = n;
    }
    var areaCm2;
    try { areaCm2 = evaluateFormula(formula, vars); } catch (e) { return null; }
    if (!isFinite(areaCm2) || areaCm2 <= 0) return null;

    var totalEur = a * areaCm2 + b;
    if (!isFinite(totalEur) || totalEur <= 0) return null;
    return toCharmPrice(totalEur);
  }

  window.CoverPricing = { computePrice: computePrice, evaluateFormula: evaluateFormula, DIMENSION_KEYS: DIMENSION_KEYS };

  // --- Glue: ans bestehende Maß-UI hängen ----------------------------------

  // Feld-Key aus der Input-id ("measurements__field-height_back" -> "height_back").
  function fieldKey(input) {
    return input.id.replace("measurements__field-", "").replace("-virtual", "");
  }

  // Geldbetrag exakt wie das Theme formatieren (kanonischer Shopify-formatMoney,
  // gespeist aus shop.money_format). cents = ganzzahlige Cent.
  function formatMoney(cents, format) {
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function f(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return "0";
      var str = (number / 100).toFixed(precision);
      var parts = str.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var rest = parts[1] ? decimal + parts[1] : "";
      return dollars + rest;
    }
    var value = "";
    var match = format.match(placeholderRegex);
    switch (match ? match[1] : "amount") {
      case "amount": value = f(cents, 2, ",", "."); break;
      case "amount_no_decimals": value = f(cents, 0, ",", ""); break;
      case "amount_with_comma_separator": value = f(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = f(cents, 0, ".", ""); break;
      case "amount_with_apostrophe_separator": value = f(cents, 2, "'", "."); break;
      case "amount_with_space_separator": value = f(cents, 2, " ", ","); break;
      case "amount_no_decimals_with_space_separator": value = f(cents, 0, " ", ""); break;
      default: value = f(cents, 2, ".", ",");
    }
    return format.replace(placeholderRegex, value);
  }

  function initRoot(root) {
    if (root.dataset.coverPricingReady === "1") return;

    var cfgEl = root.querySelector("[data-cover-config]");
    if (!cfgEl) return;

    var config;
    try {
      config = JSON.parse(cfgEl.textContent);
    } catch (e) { return; }
    if (!config) return;

    // Echte (eingereichte) Maß-Inputs – diese tragen die Werte für den Warenkorb.
    // Liegen alle innerhalb des .measurements-Roots (Original + virtuelle Modal-Felder).
    var originals = root.querySelectorAll(".measurements__form-original input");
    if (!originals.length) return;
    // Alle Inputs (Original + virtuell aus dem Modal/eigene Tastatur) anhören,
    // damit die Vorschau auch bei Eingabe über die On-Screen-Tastatur reagiert.
    var allInputs = root.querySelectorAll(".measurements__field input");
    // Preis-Block: NUR im selben Produktformular schreiben, sonst würden auch
    // Preise anderer Produkte (Empfehlungen etc.) überschrieben.
    var scope = root.closest("form") || document;
    var priceEls = scope.querySelectorAll("[data-product-price]");
    if (!priceEls.length) return;
    // ATC-Button-Preis (optional): eigener Marker, damit der generische
    // data-product-price-Loop ihn NICHT überschreibt – dort gilt ein eigenes
    // Format (Separator) und Sichtbarkeits-Verhalten.
    var atcPriceEls = scope.querySelectorAll("[data-cover-atc-price]");

    var themeShop = (window.themeCore && window.themeCore.objects && window.themeCore.objects.shop) || {};
    var moneyFormat = themeShop.money_format || "€{{amount_with_comma_separator}}";
    var placeholder = root.getAttribute("data-cover-placeholder") || "Preis nach Maßeingabe";

    // Sichtbare Warenkorb-Properties (ohne '_'), die wir aus den Eingabefeldern spiegeln.
    var mirrors = {};
    root.querySelectorAll("[data-cover-mirror]").forEach(function (m) {
      mirrors[m.getAttribute("data-cover-mirror")] = m;
    });

    function readDims() {
      var dims = {};
      originals.forEach(function (inp) { dims[fieldKey(inp)] = inp.value; });
      return dims;
    }
    // Gültigkeit eines Felds – spiegelt mk_measurement.validate (Ganzzahl, min/max).
    // Leer ist nur ok, wenn das Feld nicht 'required' ist.
    function inputOk(inp) {
      var v = inp.value;
      if (v === "") return !inp.hasAttribute("required");
      if (!/^(0|[1-9]\d*)$/.test(v)) return false;
      var num = Number(v);
      if (!isFinite(num)) return false;
      var min = inp.getAttribute("min"), max = inp.getAttribute("max");
      if (min && num < Number(min)) return false;
      if (max && num > Number(max)) return false;
      return true;
    }
    function allValid() {
      for (var i = 0; i < originals.length; i++) { if (!inputOk(originals[i])) return false; }
      return true;
    }
    function syncMirrors() {
      originals.forEach(function (inp) {
        var m = mirrors[fieldKey(inp)];
        if (!m) return;
        var unit = m.getAttribute("data-cover-unit") || "";
        m.value = inp.value === "" ? "" : (unit ? inp.value + " " + unit : inp.value);
      });
    }
    function render() {
      syncMirrors();
      // Bei ungültiger/unvollständiger Eingabe keinen Preis berechnen -> Platzhalter.
      var price = allValid() ? window.CoverPricing.computePrice(config, readDims()) : null;
      var text = price == null ? placeholder : formatMoney(price * 100, moneyFormat);
      priceEls.forEach(function (el) { el.textContent = text; });
      // ATC-Button: nur die Zahl spiegeln (Separator + Format bleiben im Liquid).
      // Ohne gültigen Preis ausblenden – der lange Platzhalter passt nicht in den Button.
      atcPriceEls.forEach(function (el) {
        if (price == null) { el.classList.add("hidden"); return; }
        var amt = el.querySelector("[data-cover-atc-amount]") || el;
        amt.textContent = text;
        el.classList.remove("hidden");
      });
    }

    // rAF entkoppelt vom 'input'-Event, damit die Original-Inputs (die mk_measurement
    // synchron aus den virtuellen Feldern befüllt) zum Lesezeitpunkt aktuell sind.
    var raf = null;
    function schedule() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(render);
    }
    allInputs.forEach(function (inp) { inp.addEventListener("input", schedule); });

    root.dataset.coverPricingReady = "1";
    render();
  }

  function initAll() { document.querySelectorAll("[data-cover-pricing]").forEach(initRoot); }
  if (document.readyState !== "loading") initAll();
  else document.addEventListener("DOMContentLoaded", initAll);
  // OS 2.0: bei Section-Re-Render (z.B. Variantenwechsel) erneut initialisieren.
  document.addEventListener("shopify:section:load", initAll);
})();
